import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import logo from "img/FS_logotipo_beta_branco.png";
import loginImage from "img/img-login.jpg";

import config from "config.json";
import { changePass } from "services/auth_service";

function App() {
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [repeatPass, setRepeatPass] = useState("");
  const [success, setSuccess] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [token, setToken] = useState("");

  useEffect(() => {
    const windowUrl = window.location.search;
    const params = new URLSearchParams(windowUrl);

    const token = params.get("code");

    //TODO ADD VALIDATION IF NOT EXISTING CODE IT WONT WORK. SHOULD SHOW ERROR
    setToken(token);
  }, []);


  const submitForm = async () => {
    if (password !== repeatPass) {
      setErrorMsg(t("ERROR_password_match_repeat"));
      return;
    }

    if (password.length < config.MIN_PASSWORD_CHAR) {
      setErrorMsg("ERROR_pass_min_length", { chars: config.MIN_PASSWORD_CHAR });
      return;
    }

    try {
      setDisableSubmit(false);
      await changePass(password, token);
      setSuccess(true);
    } catch (exception) {
      setErrorMsg(t("ERROR_unexpected"));
      console.log("exception", exception);
    }
  };

  return (
    <div className="login">
      <div
        className="columns"
        style={{
          height: "100%",
          backgroundImage: `url(${loginImage})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          alignItems: "stretch",
        }}
      >
        <div className="column is-one-third login-side column-style">
          <section className="section logo" style={{ display: "flex" }}>
            <img src={logo} alt="" style={{ height: "125px", width: "125px" }} />
          </section>
          <div className="column">
            <section className="section" style={{ padding: "0" }}>
              <div className="block">
              <nav className="breadcrumb" aria-label="breadcrumbs">
                <ul>
                  <li>
                    <Link to={"/login"}>
                    Login
                    </Link>
                  </li>
                  <li className="is-active">
                      &nbsp;&nbsp;{t("change_pass")}
                  </li>
                </ul>
              </nav>
              </div>

              <div className="block">
                <h3 className="title is-4">{t("change_pass")}</h3>
              </div>

              <div className="block">
                <div className="field">
                  <p className="control has-icons-left has-icons-right">
                    <input
                      className="input"
                      type="password"
                      value={password}
                      onChange={(event) => setPassword(event.target.value)}
                      placeholder={t("pass")}
                    />
                    <span className="icon is-small is-left">
                      <i className="fas fa-envelope"></i>
                    </span>
                  </p>
                </div>
              </div>
              <div className="block">
                <div className="field">
                  <p className="control has-icons-left">
                    <input
                      className="input"
                      type="password"
                      value={repeatPass}
                      onChange={(event) => setRepeatPass(event.target.value)}
                      placeholder={t("repeat_password")}
                    />
                    <span className="icon is-small is-left">
                      <i className="fas fa-lock"></i>
                    </span>
                  </p>
                </div>
              </div>

              <div className="block">
                <button
                  className="button btn1 is-link is-fullwidth"
                  type="submit"
                  onClick={submitForm}
                  disabled={disableSubmit}
                >
                  {t("change_pass")}
                </button>
              </div>

              {errorMsg !== "" && (
                <div>
                  <article className="message is-warning">
                    <div className="message-body">{errorMsg}</div>
                  </article>
                </div>
              )}

              {success !== false && (
                <div>
                  <article className="message is-success">
                    <div className="message-body">
                      {t("SUCCESS_password_changed")}{" "}
                      <a href="/inicio">{t("here")}</a>.
                    </div>
                  </article>
                </div>
              )}
            </section>
          </div>

          <div className="column"></div>
        </div>
      </div>
    </div>
  );
}
export default App;
